/*eslint-disable*/
export const messages = {
  "Cancel": "キャンセル",
  "Change theme": "テーマを変更",
  "Clear chat": "チャットをクリア",
  "Clear chat history": "チャット履歴をクリア",
  "Connecting...": "接続中...",
  "Continue": "続ける",
  "Decrease font size": "フォントサイズを小さく",
  "Disclaimer": "免責事項",
  "Enter your message...": "メッセージを入力...",
  "Type your message...": "メッセージを入力...",
  "Error": "エラー",
  "Font size": "フォントサイズ",
  "Increase font size": "フォントサイズを大きく",
  "Language": "言語",
  "MJ Lab": "MJラボ",
  "Reset font size": "フォントサイズをリセット",
  "Respond time: {time}s": "応答時間：{time}秒",
  "Response time:": "応答時間：",
  "Send": "送信",
  "Settings": "設定",
  "Support the project": "プロジェクトを支援",
  "System": "システム",
  "Theme": "テーマ",
  "Thinking...": "考え中...",
  "Toggle theme": "テーマ切替",
  "Welcome to {{name}} by MJ": "MJの{{name}}へようこそ",
  "You asked:": "あなたの質問：",
  
  // Headers
  "Labor Law Expert": "労働法専門家",
  "by MJ": "MJによる",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "こんにちは、私はMJによって作られたAIアシスタントの{{name}}です。",
  "I am expert in labor laws and regulations for Saudi Arabia.": "私はサウジアラビアの労働法と規制について専門知識を持っています。",
  "Ask me a question, and I will gladly answer you.": "質問をしてください、喜んでお答えします。",
  "Do not share confidential data.": "機密データを共有しないでください。",
  "I am powered using": "私は以下を使用して動作しています",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**免責事項：** {{name}}は、サウジアラビアの労働法と規制のデータを使用して応答するように設計された実験的なAIアシスタントであり、推測や不正確さを避けています。その行動や回答の正確性については責任を負いません。",
  
  // Frameworks - keeping these for backward compatibility
  "Automatic detection": "自動検出",
  "Labor Law": "労働法",
  "Saudization": "サウジ化",
  "Contracts": "契約",
  "Termination": "終了",
  "Wages & Benefits": "賃金と福利厚生",
  "Leave Policies": "休暇ポリシー",
  "Workplace Safety": "職場安全",
  
  // Models
  "Claude by Anthropic": "AnthropicによるClaude",
  "DeepSeek by Groq": "GroqによるDeepSeek",
  "MJ Lab Mode": "MJラボモード",
  
  // Character count
  "{{remainingChars}} character left": "残り{{remainingChars}}文字",
  "{{remainingChars}} characters left": "残り{{remainingChars}}文字",
  
  // Error messages
  "An error occurred": "エラーが発生しました",
  "Failed to change language": "言語の変更に失敗しました",
  "Please try again": "もう一度お試しください",
  "Connection lost": "接続が切断されました",
  "Reconnecting...": "再接続中...",
  "Nothing to clear": "クリアするものがありません",
  "All messages cleared": "すべてのメッセージがクリアされました",
  "All data cleared": "すべてのデータがクリアされました",
  "Storage limit reached": "ストレージ制限に達しました",
  "Some older messages were removed to save space.": "スペースを確保するため、一部の古いメッセージが削除されました。",
  
  // Additional keys
  "Font Size": "フォントサイズ",
  "Language changed to {locale}": "言語が{locale}に変更されました",
  "Select language": "言語を選択",
  "Support": "サポート",
  
  // Brand names (do not translate)
  "Leen": "Leen",
  
  // Message actions
  "Message copied to clipboard": "メッセージをクリップボードにコピーしました",
  "Read": "読む",
  "Summarize": "要約",
  
  // Ice Breakers Dialog
  "Message Suggestions": "メッセージの提案",
  "Select a question to quickly start a conversation about Saudi labor laws.": "サウジアラビアの労働法についての会話をすぐに始めるには質問を選択してください。",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?": "サウジアラビアの労働法における主要な従業員の権利は何ですか？簡単な概要を提供していただけますか？",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?": "サウジアラビアにおける労働時間、残業、休暇に関する雇用主の義務は何ですか？",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?": "サウジアラビアの労働法では、雇用の終了と退職金をどのように扱っていますか？",
  
  // Audio Player Dialog
  "AI Summary": "AI要約",
  "Listen to the summarized response using our AI Service.": "AIサービスを使用して要約された回答を聞きます。",
  "Generating summary...": "要約を生成中...",
  "Preparing audio...": "音声を準備中...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "テキストの処理に失敗しました。もう一度お試しください。",
  "Failed to auto-play audio. Click play to try again.": "音声の自動再生に失敗しました。再生をクリックして再試行してください。",
  "Failed to load audio. Please try again.": "音声の読み込みに失敗しました。もう一度お試しください。",
  "Audio playback was aborted.": "音声再生が中断されました。",
  "Network error occurred while loading audio.": "音声の読み込み中にネットワークエラーが発生しました。",
  "Audio decoding failed.": "音声のデコードに失敗しました。",
  "Audio format not supported.": "音声フォーマットがサポートされていません。",
  "Failed to setup audio playback": "音声再生の設定に失敗しました",
  "Failed to generate speech": "音声生成に失敗しました",
  "Failed to generate audio. Please try again.": "音声の生成に失敗しました。もう一度お試しください。",
  "Failed to play audio. Please try again.": "音声の再生に失敗しました。もう一度お試しください。",
  
  // Update Notifications
  "update.updateAvailable": "アップデートが利用可能",
  "update.newVersionAvailable": "新しいバージョン {{version}} が利用可能",
  "update.refreshToApply": "最新の機能と改善を適用するには更新してください",
  "update.later": "後で",
  "update.updateNow": "今すぐ更新",

  // CSAT Feedback
  "We Value Your Feedback": "あなたのフィードバックを大切にします",
  "Give Feedback": "フィードバックを送る",
  "How would you rate your experience?": "体験をどのように評価しますか？",
  "Very Dissatisfied": "非常に不満",
  "Dissatisfied": "不満",
  "Neutral": "普通",
  "Satisfied": "満足",
  "Very Satisfied": "非常に満足",
  "Select a rating": "評価を選択してください",
  "Comments or Bug Report": "コメントまたはバグレポート",
  "Please share your thoughts or report any issues...": "ご意見やご報告をお聞かせください...",
  "Contact Number": "連絡先番号",
  "Feedback Type": "フィードバックの種類",
  "Select a feedback type": "フィードバックの種類を選択してください",
  "Loading...": "読み込み中...",
  "No feedback types available": "フィードバックタイプが利用できません", 
  "(Optional)": "(任意)",
  "Feedback Submitted": "フィードバックが送信されました",
  "Thank you for your feedback!": "フィードバックありがとうございます！",
  "Rating Required": "評価が必要です",
  "Please select a rating before submitting.": "送信する前に評価を選択してください。",
  "Submit Feedback": "フィードバックを送信",
  "Submitting...": "送信中...",
  "General": "一般",
  "Bug": "バグ",
  "Idea": "アイデア",
  
  // Feedback Dashboard
  "Feedback Dashboard": "フィードバックダッシュボード",
  "Total Feedbacks": "フィードバック総数",
  "All-time submissions": "すべての送信",
  "Average Rating": "平均評価",
  "Out of 5 stars": "5つ星中",
  "Feedback with Comments": "コメント付きフィードバック",
  "Detailed feedback": "詳細なフィードバック",
  "Rating Distribution": "評価分布",
  "Breakdown of user satisfaction": "ユーザー満足度の内訳",
  "Rating Percentage": "評価パーセンテージ",
  "Proportion of each rating": "各評価の割合",
  "Responses": "回答",
  "All Feedback": "すべてのフィードバック",
  "Detailed view of user submissions": "ユーザー送信の詳細ビュー",
  "ID": "ID",
  "Rating": "評価",
  "Comment": "コメント",
  "Contact": "連絡先",
  "Date": "日付",
  "Page": "ページ",
  "No feedback data available": "フィードバックデータはありません",
  "No comment": "コメントなし",
  "Not provided": "提供なし",
  "Not available": "利用不可",
  
  // Authentication
  "Login": "ログイン",
  "Register": "登録",
  "Username": "ユーザー名",
  "Password": "パスワード",
  "Confirm Password": "パスワードの確認",
  "Email": "メール",
  "Full Name": "氏名",
  "Don't have an account?": "アカウントをお持ちでないですか？",
  "Already have an account?": "すでにアカウントをお持ちですか？",
  "Login to continue": "続けるにはログインしてください",
  "Create an account": "アカウントを作成",
  "Passwords must match": "パスワードが一致する必要があります",
  "Invalid email": "無効なメール",
  "Required": "必須",
  "Unauthorized": "権限なし",
  "You don't have permission to access this page.": "このページにアクセスする権限がありません。"
};